<h2 mat-dialog-title class="dialog-title">
  {{ 'refreshRequired' | i18nextCap }}
</h2>
<mat-dialog-content>
  <p class="dialog-explanation">
    {{ 'refreshRequiredExplanation' | i18nextCap }}
  </p>
  <p class="dialog-explanation">{{ 'refreshRequiredWarning' | i18nextCap }}</p>
</mat-dialog-content>
<mat-dialog-actions align="center" class="dialog-actions">
  <button mat-flat-button [mat-dialog-close]="false">
    {{ 'refreshLater' | i18nextCap }}
  </button>
  <button mat-flat-button color="primary" [mat-dialog-close]="true">
    {{ 'refreshNow' | i18nextCap }}
  </button>
</mat-dialog-actions>
